<!--
 * @Author: 仙道
 * @Date: 2022-09-18 14:26:58
 * @LastEditTime: 2022-09-26 13:53:15
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/jeecg/JTreeSelectDevice.vue
-->
<template>
  <a-tree-select
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :filterTreeNode="filterTreeNode"
    :getPopupContainer="getPopupContainer"
    :labelInValue="true"
    :multiple="multiple"
    :placeholder="placeholder"
    :treeData="treeData"
    :value="treeValue"
    @change="onChange"
    @search="onSearch"
    allowClear
    labelInValue
    show-search
    style="width: 100%"
    treeNodeFilterProp="title"
  ></a-tree-select>
</template>
<script>
  // :loadData="asyncLoadTreeData"
  /*
   * 异步树加载组件 通过传入表名 显示字段 存储字段 加载一个树控件
   * <j-tree-select dict="aa_tree_test,aad,id" pid-field="pid" ></j-tree-select>
   * */
  import { getAction, postAction } from '@/api/manage'

  export default {
    name: 'JTreeSelectDevice',
    props: {
      getPopupContainer: {
        type: Function,
        default: node => node.parentNode
      },
      value: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        default: '请选择',
        required: false
      },
      dict: {
        type: String,
        default: '',
        required: false
      },
      pidField: {
        type: String,
        default: 'pid',
        required: false
      },
      pidValue: {
        type: String,
        default: '',
        required: false
      },
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      hasChildField: {
        type: String,
        default: '',
        required: false
      },
      condition: {
        type: String,
        default: '',
        required: false
      },
      // 是否支持多选
      multiple: {
        type: Boolean,
        default: false
      },
      loadTriggleChange: {
        type: Boolean,
        default: false,
        required: false
      },
      // 不走统一封装的字典请求
      fetchType: {
        type: String,
        default: 'dict'
      },
      // 自定义tree接口
      fetchApi: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        treeValue: null,
        treeData: [],
        url: '/device/devList/getProcessDevTree',
        view: '/sys/dict/loadDictItem/',
        tableName: '',
        text: '',
        code: ''
      }
    },
    watch: {
      value () {
        this.loadItemByCode()
      },
      dict () {
        this.initDictInfo()
        this.loadRoot()
      }
    },
    created () {
      this.validateProp().then(() => {
        this.initDictInfo()
        this.loadRoot()
        this.loadItemByCode()
      })
    },
    methods: {
      filterTreeNode (inputValue, treeNode) {
        return treeNode.componentOptions.propsData.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      },
      loadItemByCode () {
        if (!this.value || this.value == '0') {
          this.treeValue = null
        } else {
          // const action_url = this.fetchType === 'dict' ? `${this.view}${this.dict}` : this.loadUrl
          postAction(`/device/devList/getDevListByIds`, this.value.split(',')).then(res => {
            if (res.success) {
              const result = res.result.map(list => list.devName)
              let values = this.value.split(',')

              this.treeValue = result.map((item, index) => ({
                key: values[index],
                value: values[index],
                label: item
              }))
              this.onLoadTriggleChange(result[0])
            }
          })
        }
      },
      onLoadTriggleChange (text) {
        //只有单选才会触发
        if (!this.multiple && this.loadTriggleChange) {
          this.$emit('change', this.value, text)
        }
      },
      initDictInfo () {
        let arr = this.dict.split(',')
        this.tableName = arr[0]
        this.text = arr[1]
        this.code = arr[2]
      },
      asyncLoadTreeData (treeNode) {
        return new Promise(resolve => {
          if (treeNode.$vnode.children) {
            resolve()
            return
          }
          let pid = treeNode.$vnode.key
          let param = {
            devProcessId: pid
          }
          // const action_url = this.fetchType === 'dict' ? this.url : this.loadUrl
          getAction(this.url, param).then(res => {
            if (res.success) {
              const result =
                res.result.length > 0 &&
                res.result[0].children.map(item => {
                  item.parentId = pid
                  item.isLeaf = true
                  item.value = item.key
                  return item
                })
              this.addChildren(pid, result ?? [], this.treeData)
              this.treeData = [...this.treeData]
            }
            resolve()
          })
        })
      },
      addChildren (pid, children, treeArray) {
        if (treeArray && treeArray.length > 0) {
          for (let item of treeArray) {
            if (item.key == pid) {
              if (!children || children.length == 0) {
                item.isLeaf = true
              } else {
                item.children = children
              }
              break
            } else {
              this.addChildren(pid, children, item.children)
            }
          }
        }
      },
      loadRoot () {
        getAction(this.url).then(res => {
          if (res.success && res.result) {
            const result =
              res.result.length > 0 &&
              res.result.map(item => {
                item.children = item.children.map(children => {
                  children.value = children.key
                  children.isLeaf = true
                  children.dataType = 'device'
                  children.parentId = item.key
                  return children
                })
                item.isLeaf = !item.children.length > 0
                item.value = item.key
                item.dataType = 'process'
                // item.disabled = true
                return item
              })

            this.treeData = [...result]
          } else {
            console.log('数根节点查询结果-else', res)
          }
        })
      },
      onChange (value, label, e) {
        const dataType = e?.triggerNode?.dataRef && e?.triggerNode?.dataRef.type === 'process'
        if (dataType) {
          this.$message.error('当前选择节点类型为供水流域，请选择设备')
          return
        }
        if (!value) {
          this.$emit('change', '')
          this.treeValue = null
        } else if (value instanceof Array) {
          this.$emit('change', value.map(item => item.value).join(','), value, e?.triggerNode?.dataRef)
          this.treeValue = value
        } else {
          this.$emit('change', value.value, value.label)
          this.treeValue = value
        }
      },
      onSearch (value) {
        console.log(value)
      },
      getCurrTreeData () {
        return this.treeData
      },
      validateProp () {
        let mycondition = this.condition
        return new Promise((resolve, reject) => {
          if (!mycondition) {
            resolve()
          } else {
            try {
              let test = JSON.parse(mycondition)
              if (typeof test == 'object' && test) {
                resolve()
              } else {
                this.$message.error('组件JTreeSelect-condition传值有误，需要一个json字符串!')
                reject()
              }
            } catch (e) {
              this.$message.error('组件JTreeSelect-condition传值有误，需要一个json字符串!')
              reject()
            }
          }
        })
      }
    },
    //2.2新增 在组件内定义 指定父组件调用时候的传值属性和事件类型 这个牛逼
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>
